import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { SsoLoginService } from "@core/services/sso-login.service";

@Component({
  selector: "app-login",
  template: `
    <p *ngIf="showError" role="alert">
      Não foi possível iniciar sua sessão. Redirecionando para o login.
    </p>
  `,
  standalone: false
})
export class LoginComponent implements OnInit {
  showError = false;

  constructor(
    private keycloakService: KeycloakService,
    private ssoLoginService: SsoLoginService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    if (await this.keycloakService.isLoggedIn()) {
      await this.router.navigateByUrl("/");
      return;
    }

    this.showError = this.ssoLoginService.hasFailureMessage();
    if (this.showError) {
      window.setTimeout(() => {
        void this.ssoLoginService.redirectToTraditionalLogin();
      });
      return;
    }

    await this.ssoLoginService.redirectToTraditionalLogin();
  }
}
